export default "__VITE_ASSET__3c9ce173__"